import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosLegal = ({ ruta, legal }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Legal")}
            eyebrow={t("Empresa")}
            imagen={legal.imagen_cabecera ? ruta + "/" + legal.imagen_cabecera : null}
            html={legal.ladesc}
        />
    );
}

export default TextosLegal;
